<nav class="navbar head-nav">
  <h2>{{ 'header.my_profile' | translate }}</h2>
  <ol class="breadcrumb">
    <li class="breadcrumb-item">
      <a [routerLink]='["/"]'>{{ 'header.home' | translate }}</a>
    </li>
    <li class="breadcrumb-item">{{ 'header.my_profile' | translate }}</li>
  </ol>
</nav>
<div *ngIf='dataLoading' class="dataLoading">
  <mat-spinner class="m-auto" diameter="50"></mat-spinner>
</div>

<ng-container *ngIf='!dataLoading && this.user'>
  <div class="container-fluid px-0">
    <div class="row mx-0 justify-content-center">
      <div class="col-sm-12 col-md-8">
        <div class="card_info_profile">
          <div class="card_info_profile_content">
            <div class="top_profile_user">
              <div class="user_info_avatar">
                <img *ngIf="avatarSrc" [src]="avatarSrc" (error)='avatarSrc = ""'>
                <span *ngIf="!avatarSrc">{{ user.profileDetails.fullName | shortName }}</span>
                <label class="icon-label-upload" for="uploadAvatar">
                  <input type='file' class="d-none" id="uploadAvatar" accept="image/jpeg, image/pjpeg, image/png"
                    (change)="uploadAvatar($event)">
                  <img src="assets/images/icons/insert-picture-icon.svg" alt="">
                </label>
              </div>
              <p class="invalid-feedback mt-2 d-block" *ngIf="fileTypeError">{{ 'forms.InvalidFile' | translate }}</p>
              <p class="invalid-feedback mt-2 d-block" *ngIf="fileSizeError">{{ 'forms.Max-files' | translate }}
                {{maxFileSize}} Mb</p>
              <div class="actions_profile mb-3" [hidden]="!avatar">
                <button mat-raised-button [disabled]="loading" [class.loading]='loading' class="mat-outline primary"
                  type="button" (click)="clear()">
                  {{ 'swalMsg.cancel' | translate }}
                </button>
                <button mat-raised-button [disabled]="loading" [class.loading]='loading' color="primary" type="button"
                  (click)="updateAvatar()">
                  {{ 'forms.save_changes' | translate }}
                </button>
              </div>
              <h4>
                {{user.profileDetails.fullName}}
              </h4>
              <h5>
                {{user.profileDetails.userName}}
              </h5>
            </div>
            <div class="profile_detail text-center">
              <ul class="list-items border-0">
                <li>
                  <span class="title">
                    {{ 'user_management.user_id' | translate }}
                  </span>
                  <div class="desc">
                    {{user.profileDetails.userId}}
                  </div>
                </li>
                <li>
                  <span class="title">
                    {{ 'administration.phone' | translate }}
                  </span>
                  <div class="desc">
                    {{user.profileDetails.phone}}
                  </div>
                </li>
                <li>
                  <span class="title">
                    {{ 'user_management.email' | translate }}
                  </span>
                  <div class="desc">
                    <a [href]="'mailto:'+user.profileDetails.email">{{user.profileDetails.email}}</a>
                  </div>
                </li>
              </ul>
              <div class="actions_profile">
                <button mat-raised-button class="mat-outline primary my-1" type="button" (click)="changePassword()"
                appAccessControl [accessRoles]="actions.MyProfileChangePassword">
                  {{ 'user_management.change_password' | translate }}
                </button>
                <a mat-raised-button color="primary" [routerLink]="['/admin/user-preferences']">
                  {{ 'user_management.user_preferences' | translate }}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>